import { motion } from "framer-motion";

// Fade from Left
export const MotionFadeLeft = ({ children, delay = 0, duration = 1 }) => (
  <motion.div
    initial={{ opacity: 0, x: -100 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration, delay, ease: "easeOut" }}
    viewport={{ once: false, amount: 0.3 }}
  >
    {children}
  </motion.div>
);

// Fade from Right
export const MotionFadeRight = ({ children, delay = 0, duration = 1 }) => (
  <motion.div
    initial={{ opacity: 0, x: 100 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration, delay, ease: "easeOut" }}
    viewport={{ once: false, amount: 0.3 }}
  >
    {children}
  </motion.div>
);

// Fade from Bottom
export const MotionFadeUp = ({ children, delay = 0, duration = 1 }) => (
  <motion.div
    initial={{ opacity: 0, y: 100 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration, delay, ease: "easeOut" }}
    viewport={{ once: false, amount: 0.3 }}
  >
    {children}
  </motion.div>
);

// Fade from Top
export const MotionFadeDown = ({ children, delay = 0, duration = 1 }) => (
  <motion.div
    initial={{ opacity: 0, y: -100 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration, delay, ease: "easeOut" }}
    viewport={{ once: false, amount: 0.3 }}
  >
    {children}
  </motion.div>
);

// Zoom In
export const MotionZoomIn = ({ children, delay = 0, duration = 1 }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.8 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ duration, delay, ease: "easeOut" }}
    viewport={{ once: false, amount: 0.3 }}
  >
    {children}
  </motion.div>
);

// Rotate In
export const MotionRotate = ({
  children,
  delay = 0,
  duration = 1,
  rotate = 45,
}) => (
  <motion.div
    initial={{ opacity: 0, rotate }}
    whileInView={{ opacity: 1, rotate: 0 }}
    transition={{ duration, delay, ease: "easeOut" }}
    viewport={{ once: false, amount: 0.3 }}
  >
    {children}
  </motion.div>
);

// Staggered Group (Generic)
export const MotionStaggerGroup = ({
  children,
  stagger = 0.2,
  delay = 0,
  duration = 1,
}) => {
  const variants = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: stagger,
        delayChildren: delay,
        duration,
        ease: "easeOut",
      },
    },
  };

  return (
    <motion.div
      variants={variants}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.3 }}
    >
      {children}
    </motion.div>
  );
};

// NEW: Stagger List (map'li kullanım için)
export const MotionStaggerList = ({
  children,
  stagger = 0.2,
  delay = 0.2,
  duration = 0.6,
  repeat = false,
}) => {
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: stagger,
        delayChildren: delay,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration, ease: "easeOut" },
    },
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      whileInView="show"
      viewport={{ once: !repeat, amount: 0.3 }}
      className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 md:gap-14"
    >
      {children.map((child, index) => (
        <motion.div key={index} variants={itemVariants}>
          {child}
        </motion.div>
      ))}
    </motion.div>
  );
};

// Parallax (slow scroll effect)
export const MotionParallax = ({ children, speed = 0.3 }) => (
  <motion.div
    initial={{ y: 0 }}
    whileInView={{ y: -window.innerHeight * speed }}
    transition={{ duration: 1, ease: "easeOut" }}
    viewport={{ once: false, amount: 0 }}
  >
    {children}
  </motion.div>
);
